import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {captureParkingSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {incidentsService} from "../services";

export default function useIncidentReportUpdate() {
  const invalidateIncidentReport = useInvalidate("incidentReport");
  const invalidateIncidentReports = useInvalidate("incidentReports");

  return useMutation({
    mutationFn: (data: Record<string, unknown>) => {
      const id = data.incident_report_id as number;
      return incidentsService.updateIncidentReport(id, data);
    },
    onSuccess: () => {
      invalidateIncidentReport();
      invalidateIncidentReports();
      toast.success("Incident report updated successfully", TOAST_CONFIG);
    },
    onError: (error) => {
      captureParkingSubmitError(error, {feature: "incidents", operation: "incident_update"});
    },
  });
}
